export { HeroModule } from "./HeroModule";
